import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getPatientDemographicsOptionsSelector } from '../selectors/patientDemographicsOptions.selector'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { setPhoneDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { OptionsConstants } from '../store/options.constants'
import { IPatientDemographicsOptionsState } from '../store/options.types'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'

export function* setPhoneNumber() {
  const patientDemographicsOptions: IPatientDemographicsOptionsState = yield select(
    getPatientDemographicsOptionsSelector
  )
  const { number, phoneDetail } = patientDemographicsOptions
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { phoneDetails } = patientDemographics
  const selectedPhone = phoneDetails.filter((phone) => phone.key === phoneDetail?.key)
  if (selectedPhone && selectedPhone.length) {
    selectedPhone[0].number = number
    yield put(setPhoneDetails(phoneDetails))
  }
}

export function* setPhoneNumberSaga() {
  yield takeLatest([OptionsConstants.SET_PHONE], setPhoneNumber)
}
